import React from "react";
import styles from "./PlayBtn.module.css";
import playImg from "../../../../assets/images/common/icons/play.svg";
import pauseImg from "../../../../assets/images/common/icons/pause.svg";

const PlayBtn = ({ onChange, defaultChecked, btnRef, ...props }) => {
  return (
    <div className={styles.playBtn}>
      <input
        className={styles.playBtnInput}
        id={"playBtnCheck"}
        ref={btnRef}
        type={"checkbox"}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      <label className={styles.playBtnLabel} htmlFor={"playBtnCheck"}>
        <img className={styles.playImg} src={playImg} alt={"Play"} />
        <img className={styles.pauseImg} src={pauseImg} alt={"Pause"} />
      </label>
    </div>
  );
};

export default PlayBtn;
